import React, { useEffect, useRef, useState } from "react";
import { Constants } from "../../CommonMethhods/Constants";
import { useDebounce } from "../../Components/useDebounce";
import axios from "axios";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  decryptData,
  encryptData,
  formatDate,
  formatDateMonth,
  noDataFound,
  getCurrentFinancialYear,
} from "../../CommonMethhods/CommonMethods";
import {
  Client_Search,
  MFReports,
  MutualFund,
} from "../../Configuration/API_URL";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import { toast } from "react-toastify";
import moment from "moment";
import SmallLoader from "../../Components/Common/smallLoader";
import DurationChangeComponent from "../Reports/DurationChangeComponent";
import FromdateComponent from "../Reports/FromdateComponent";
import TodateComponent from "../Reports/TodateComponent";
import MFDuration from "./MFDuration";
import MFFundHoldingReportTable from "../../Components/ReportTables/MFFundHoldingReportTable";

export default function FundHolding() {
  const storeToken = localStorage.getItem("ssoToken");
  const [clientList, setClientList] = useState([]);
  const [clientCode, setClientCode] = useState("");
  const [page, setPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const debouncedClientCode = useDebounce(clientCode, 1000);
  const [noNameFoundError, setNoNameFoundError] = useState("");
  const [count, setCount] = useState(0);
  const calanderIcon = true;
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [dataCount, setDataCount] = useState();
  const [offset, setOffset] = useState(1);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [scrollLoaderTable, setScrollLoaderTable] = useState(false);
  const [mainError, setMainError] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [selectedYear, setSelectedYear] = useState("");
  const [yearError, setYearError] = useState(false);
  const [errorGrid, setErrorGrid] = useState(false);
  const [fromDateError, setFromDateError] = useState(false);
  const [toDateError, setToDateError] = useState(false);
  const [hasVerticalScroll, setHasVerticalScroll] = useState(false);
  const tableBodyRef = useRef(null);
  const [customShow, setCustomShow] = useState(false);

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  useEffect(() => {
    if (debouncedClientCode) {
      searchApiDetail(debouncedClientCode, 1);
      setScrollLoader(true);
      setClientList([]);
      setPage(1);
    }
  }, [debouncedClientCode]);
  useEffect(() => {
    if (page > 1) {
      searchApiDetail(clientCode, page);
    }
  }, [page]);
  const searchApiDetail = async (code, NoPage) => {
    const payloadValue = {
      keyword: code,
      Status: "",
      PageNo: NoPage,
      PageSize: 10,
    };
    const encPayload = AESEncryption(payloadValue);

    try {
      const response = await axios.post(
        Client_Search.Search_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(response?.data);

      if (res?.status === 0) {
        setCount(res?.data?.TotalCount);
        setNoNameFoundError("");
        setMainError("");
        setClientList((prev) =>
          page > 1 ? [...prev, ...res?.data?.clients] : res?.data?.clients
        );
      } else {
        setNoNameFoundError(res?.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setScrollLoader(false);
    }
  };

  const handleScroll = async (e) => {
    const element = e.target;
    if (
      element.scrollTop + element.offsetHeight + 1 >= element.scrollHeight &&
      !scrollLoader
    ) {
      if (count > 10 * page) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };

  const getFundHoldingReport = async (fileView, offsetTab) => {
    if (fileView === "excel") {
      setSmallLoaderExcel(true);
    }

    if (fileView === "grid" && offsetTab <= 1) {
      setLoader(true);
    }
    let payloadValue = {
      userId: clientCode,
      fileType: fileView,
      pageNo: fileView === "grid" ? offsetTab : -1,
      pageSize: fileView === "grid" ? 10 : -1,
      fromDate,
      endDate: toDate,
    };

    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axios.post(
        MFReports.Fund_Holding,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        if (fileView === "grid") {
          setDataCount(res?.data?.totalCount);
          if (offsetTab > 1) {
            setTableData((prev) => {
              return [...prev, ...res?.data?.fundHoldingList];
            });
          } else {
            setTableData(res?.data?.fundHoldingList);
          }

          setScrollLoaderTable(false);
        } else if (fileView === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
      } else {
        setTableData([]);
        if (fileView !== "grid") {
          toast.error(res?.message);
        } else {
          setErrorGrid(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);
      if (fileView !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
    }
  };

  const handleOnClick = (e) => {
    setOffset(1);
    setShow(false);

    const value = e.target.value;

    if (!value || !clientCode) {
      setMainError("Please Select Client Name/Code");
      setTableData([]);
      return;
    }

    getFundHoldingReport(value, 1);
  };

  const handleTableScroll = (e) => {
    const el = e.target;
    const scrolledToBottom =
      el.scrollTop + el.offsetHeight + 1 >= el.scrollHeight;

    if (scrolledToBottom && !scrollLoaderTable) {
      const nextOffset = offset + 1;
      const totalLoadedRecords = offset * 10;
      if (dataCount > totalLoadedRecords && dataCount !== tableData.length) {
        setOffset(nextOffset); // This still updates state for future reference
        setScrollLoaderTable(true);
        setLoader(false);
        getFundHoldingReport("grid", nextOffset);
      } else {
        setScrollLoaderTable(false);
      }
    }
  };

  const handleFromDateChange = (e) => {
    setFromDateError(false);
    setErrorGrid(false);
    setFromDate(e.target.value);
    setToDate(e.target.value);
    setServerError(false);
  };

  useEffect(() => {
    const el = tableBodyRef.current;

    if (!el) return;

    const checkScroll = () => {
      setHasVerticalScroll(el.scrollHeight > el.clientHeight);
    };

    checkScroll();

    const observer = new ResizeObserver(checkScroll);
    observer.observe(el);

    return () => observer.disconnect();
  }, [tableData]);

  return (
    <div>
      <div className="row input-field-wrapper">
        <div className="col-md-3 col-sm-3 col-6">
          <div className="form-group">
            <label className="form-label">
              Client Search<span className="text-danger">*</span>
            </label>
            <div className="rm-custom-dropdown">
              <input
                type="text"
                className="input-st"
                placeholder="Search here"
                autoComplete="off"
                value={clientCode}
                onChange={(e) => {
                  let value = e.target.value.toUpperCase();
                  value = value.replace(/[^A-Z0-9 ]/gi, "");
                  value = value.replace(/\s{2,}/g, " ");
                  value = value.replace(/^\s+/, "");

                  setClientCode(value);
                  setShow(true);
                }}
              />
              <button
                className="rm-dropdown-btn"
                onClick={() => setShow(!show)}
              >
                <span className="icon-right-arrow-triangle"></span>
              </button>
              {show && (
                <ul className="rm-mapping-ap border-0" onScroll={handleScroll}>
                  {clientList.map((item, i) => (
                    <li
                      key={i}
                      className="rm-maping-item-wrapper"
                      onClick={() => {
                        setClientCode(item?.clientCode);
                        setShow(false);
                      }}
                    >
                      <>
                        <div> {item?.clientname}</div>
                        <div> {item?.clientCode}</div>
                      </>
                    </li>
                  ))}
                  {scrollLoader && !loader && (
                    <div className="loader-center">
                      <LoaderForSearch />
                    </div>
                  )}
                  {noNameFoundError && !scrollLoader && (
                    <li
                      className="rm-maping-item-wrapper"
                      style={{ borderBottom: "none", fontSize: "12px" }}
                    >
                      {noNameFoundError}
                    </li>
                  )}
                </ul>
              )}
            </div>
            {mainError && (
              <span className="to-date-error main">{mainError}</span>
            )}
          </div>
        </div>

        <div className="col-md-3 col-sm-3 col-6">
          <div className="form-group calendar-icon">
            <label className="form-label">As on Date</label>
            <input
              type="date"
              placeholder="DD/MM/YYYY"
              className="datepicker form-control"
              id="FromDateCombine"
              onChange={handleFromDateChange}
              max={DateReverse}
            />
            {fromDateError && (
              <span className="to-date-error">{fromDateError}</span>
            )}
            {calanderIcon && <span className="icon-calendar ico"></span>}
          </div>
        </div>
        <div className="text-center search-btn-wrapper mb-3 ">
          <button value="grid" className="send-message" onClick={handleOnClick}>
            {Constants.Search}
          </button>
        </div>
      </div>

      <div className="table-top-nav mr-4">
        <div className="table-dt-btn">
          <button
            value="excel"
            onClick={handleOnClick}
            className="generate-button excel-btn"
          >
            {" "}
            {smallLoaderExcel ? (
              <div>
                <SmallLoader />
              </div>
            ) : (
              <>
                <span className="icon-excelsvg"></span>
                {"Excel"}
              </>
            )}
          </button>
        </div>
      </div>
      <div
        className={`mutualfund-table ${
          tableData?.length == 0 ? "nodatawrapper" : ""
        }`}
      >
        {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : tableData && tableData.length > 0 ? (
          <div className="scroll-table master_table mutualfundTab">
            {tableData && tableData?.length > 0 ? (
              <MFFundHoldingReportTable
                tableData={tableData}
                handleTableScroll={handleTableScroll}
                hasVerticalScroll={hasVerticalScroll}
                scrollLoaderTable={scrollLoaderTable}
                loader={loader}
                LoaderForSearch={LoaderForSearch}
                ref={tableBodyRef}
              />
            ) : (
              noDataFound()
            )}
          </div>
        ) : serverError ? (
          <h4 className="report-error-message">{noDataFound(serverError)}</h4>
        ) : errorGrid ? (
          noDataFound(errorGrid)
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
